<template>
  <app-modal modal-id="fund-modal-info"
             modal-size="default"
             modal-alignment="center"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{$t(infotitle)}}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div>
        {{$t(infobody)}}
      </div>
      
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel_info") }}
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
export default {
  name: "FundModal",
  props:['infotitle', 'infobody'],
  mixins: [FormSubmitMixin],
  data() {
    return {
     
     
	  
     
     
    };
  },
  computed: {
  },
  methods: {
    
  },
  mounted() {
    
  },
};
</script>
